import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { succsesDataAddAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { getStatusTitle } from "../novaposhta/NPSatuses";

const CurrentTtn = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const permissions = useSelector((state) => state.status.permissions);

    const [ttn, setTtn] = useState("");
    const [isProblem, setIsProblem] = useState(0);
    const [note, setNote] = useState("");

    const [sendForm, { isLoading, isError }] = useSendFormMutation();
    const { data: ttnData, refetch: refetchTtnData } = useGetPageQuery("ttns/" + id);
    const { data: invoice, refetch: refetchInvoice } = useGetPageQuery("nova-poshta/invoice?ttn=" + id);

    const sendFormHandler = async () => {
        const formData = {
            ttn: ttn,
            is_problem: isProblem,
            note: note,
        };

        await sendForm({ body: formData, url: "ttns/" + id, method: "PUT" }).unwrap();

        if (!isError) {
            succsesDataAddAlert();
            navigate("/novaposhta/1");
        }
    };

    useEffect(() => {
        if (ttnData && invoice) {
            setTtn(id);
            setIsProblem(ttnData.is_problem);
            setNote(ttnData.note);
        }
    }, [ttnData, invoice]);

    useEffect(() => {
        const refetch = async () => {
            refetchTtnData();
            refetchInvoice();
        };

        refetch();
    }, []);

    return (
        <>
            {ttnData && invoice && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>
                                ТТН 20450726567986
                                <div className="info_ttn float-right"></div>
                                <div className="clearfix"></div>
                            </h1>
                        </div>

                        <div className="form user_form">
                            <input
                                type="hidden"
                                name="id"
                                value="48505"
                            />
                            <input
                                type="hidden"
                                name="user_id"
                                value="60652"
                            />
                            <input
                                type="hidden"
                                name="order_id"
                                value="181189"
                            />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card">
                                        <div className="card-header">
                                            Номер ТТН
                                            <div className="custom-control custom-checkbox float-end">
                                                <input
                                                    type="checkbox"
                                                    id="check_have_problem"
                                                    name="have_problem"
                                                    className="form-check-input mx-1 mt-1"
                                                    checked={isProblem}
                                                    onChange={(e) => setIsProblem(+e.target.checked)}
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    for="check_have_problem"
                                                >
                                                    Проблемна (підміна / розбито)
                                                </label>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Номер ТТН</label>
                                                <input
                                                    className="form-control"
                                                    name="ttn"
                                                    maxLength="255"
                                                    value={ttn}
                                                    onChange={(e) => setTtn(e.target.value)}
                                                    disabled
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="d-block">Відправник </label>
                                                <input
                                                    className="form-control"
                                                    value=""
                                                    name="PhoneSender"
                                                    maxLength="255"
                                                    type="text"
                                                    required=""
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Примітка</label>
                                                <textarea
                                                    className="form-control"
                                                    name="note"
                                                    value={note}
                                                    onChange={(e) => setNote(e.target.value)}
                                                ></textarea>
                                            </div>
                                            {/* <div className="mb-3">
                                    <label className="form-label">Товари</label>
                                    <table className="table table-striped purchases_table" id="moves">
                                    </table>
                                    <div id="add_purchase">
                                        <input type="text" name="related" id="add_purchase" className="input_autocomplete form-control" placeholder="Виберіть товар, для того щоб дадати його" autocomplete="off" />
                                    </div>
                                </div> */}
                                            {permissions.includes("novaposhta_section") ||
                                            permissions.includes("all") ? (
                                                <div className="saves_block">
                                                    <button
                                                        name="user_info"
                                                        className="btn btn-primary"
                                                        onClick={sendFormHandler}
                                                    >
                                                        {isLoading ? "Завантаження" : "Зберегти"}
                                                    </button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card">
                                        <div className="card-header">Інформація ТТН</div>
                                        <div className="card-body">
                                            <table className="table table-striped">
                                                <tbody>
                                                    <tr>
                                                        <td>Номер ТТН</td>
                                                        <td>{id}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Статус</td>
                                                        <td>{getStatusTitle(ttnData.status_id, ttnData.city_to)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Дата створення</td>
                                                        <td>{ttnData.date_created}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Опис</td>
                                                        <td>{invoice.Description}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Місто отримувача</td>
                                                        <td>{ttnData.city_to}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Телефон отримувача</td>
                                                        <td>{invoice.RecipientsPhone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Отрієнтовна дата прибуття</td>
                                                        <td>
                                                            {/* {moment(invoice.PreferredDeliveryDate).format("DD.MM.YYYY")} */}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Тип оплати</td>
                                                        <td>{invoice.PayerType}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Вага, кг</td>
                                                        <td>{invoice.Weight}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Вартість доставки</td>
                                                        <td>{invoice.CostOnSite}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Місто відправника</td>
                                                        <td>{invoice.CitySenderDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Оголошена вартість</td>
                                                        <td>{invoice.Cost}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Дата отримання</td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Отримувач</td>
                                                        <td>
                                                            <Link to={"/client/" + ttnData?.order?.client_id}>
                                                                {invoice.RecipientContactPerson}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Сума повернення</td>
                                                        <td>{invoice.BackwardDeliverySum}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentTtn;
